/** Name a PDF representation without carrying over its source Office extension. */
export function pdfDownloadFilename(filename: string): string {
    const name = filename.split(/[\\/]/).pop() || "download"
    if (/\.pdf$/i.test(name)) return name
    const extensionStart = name.lastIndexOf(".")
    return `${extensionStart > 0 ? name.slice(0, extensionStart) : name}.pdf`
}
